import React from "react";

export default function EvaluationQuestionRating({ question, scaleOptions = [], value, onChange, disabled }) {
    return (
        <div className="qr-options-list qr-options-list--compact">
            {scaleOptions.map((option) => (
                <label
                    key={option.id || option.value}
                    className={`qr-option-card ${String(value) === String(option.value) ? "is-selected" : ""}`}
                >
                    <input
                        type="radio"
                        name={`evaluation-question-${question.id}`}
                        value={option.value}
                        checked={String(value) === String(option.value)}
                        onChange={() => onChange(option.value)}
                        disabled={disabled}
                    />
                    <span>{option.label || option.value}</span>
                </label>
            ))}
        </div>
    );
}
